export const SUBSITES = {
	REGIO_EXPRES: 'regio-expres',
	OP_OOST: 'op-oost',
	EFRO_OOST: 'efro-oost',
	CONDOLEANCE_REGISTER_PROVINCIE_GELDERLAND: 'condoleanceregisterprovinciegelderland',
	GEO_LINK: 'geolink',
	OPEN_GELDERLAND: 'open-gelderland'
};
